import logo from '../images/logo.png';
import albumCover from '../images/albumcover.jpg';

export const releaseConfig = {
    artist: {
      name: "The Creaks",
      logo: logo
    },
    song: {
      title: "Arsonist",
      description: "Valentino Evangelo and Hugh Doriello traveled the world together after running away from their past and finally settled down in the beautiful city of Prague where they recorded this romantic record in late 2024.",
      albumCover: albumCover
    },
    release: {
      date: "2024-12-22T15:00:00+01:00", // ISO format for precise countdown
      platform: "Spotify"
    }
  };
  
  // Utility function for dynamic countdown
  export function getRemainingTime(targetDate) {
    const now = new Date();
    const target = new Date(targetDate);
    const difference = target.getTime() - now.getTime();
  
    if (difference <= 0) return "Released!";
  
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  
    return `Releasing in ${days}d ${hours}h ${minutes}m`;
  }